import { Field, InputType, Int, ObjectType } from 'type-graphql'

import { ObjectRef, ScalarObject } from '@things-factory/shell'

import { DataSample } from './data-sample.js'

@InputType()
export class NewDataSample {
  @Field({ nullable: true, description: 'Optional name for the data sample.' })
  name?: string

  @Field({ nullable: true, description: 'Optional description of the data sample.' })
  description?: string

  @Field(type => ObjectRef, { nullable: true, description: 'Reference to the dataset this sample belongs to.' })
  dataSet?: ObjectRef

  @Field({ nullable: true, description: 'Version of the dataset when this sample was collected.' })
  dataSetVersion?: number

  @Field(type => ScalarObject, { nullable: true, description: 'The actual collected data values for this sample.' })
  data?: any

  @Field({ nullable: true, description: 'Raw data string before processing or transformation.' })
  rawData?: string

  @Field({ nullable: true, description: 'Source of the data sample (e.g., sensor ID, manual entry, external system).' })
  source?: string

  @Field({ nullable: true, description: 'Work date when the data sample was collected.' })
  workDate?: string

  @Field({ nullable: true, description: 'Work shift when the data sample was collected.' })
  workShift?: string

  @Field({ nullable: true, description: 'Timestamp when the data sample was collected.' })
  collectedAt?: Date
}

@ObjectType({ description: 'Represents a paginated list of data samples.' })
export class DataSampleList {
  @Field(type => [DataSample], { description: 'List of data samples.' })
  items: DataSample[]

  @Field(type => Int, { description: 'Total number of data samples in the list.' })
  total: number
}
